// PaginationMobile.js
import { Flex, Button, Text } from '@chakra-ui/react';
import { ArrowPaginateIcon, DoubleArrowPaginateIcon } from 'components/Icons/Icons';

const PaginationMobile = ({
  meta,
  currentPage,
  onPageChange,
  isLoadingPage,
  setIsLoadingPage
}) => {
  const totalPages = Math.ceil(meta.total / meta.limit);

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      const newOffset = (page - 1) * meta.limit;
      onPageChange(newOffset);
      setIsLoadingPage(true);
    }
  };

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      mt="24px"
      gap="8px"
      pointerEvents={isLoadingPage ? 'none' : 'unset'}
      opacity={isLoadingPage ? '0.8' : '1'}
    >
      <Flex gap="4px">
        <Button
          onClick={() => handlePageClick(1)}
          isDisabled={currentPage === 1}
          variant="solid-lg"
          borderRadius="full"
          w="64px"
          h="56px"
          p="0"
        >
          <DoubleArrowPaginateIcon fontSize="24px" style={{ transform: 'rotate(180deg)' }} />
        </Button>
        <Button
          onClick={() => handlePageClick(currentPage - 1)}
          isDisabled={currentPage === 1}
          variant="solid-lg"
          borderRadius="full"
          w="64px"
          h="56px"
          p="0"
        >
          <ArrowPaginateIcon fontSize="24px" style={{ transform: 'rotate(180deg)' }} />
        </Button>
      </Flex>

      <Text variant="title-md" fontStyle="italic" fontWeight="900" whiteSpace="nowrap">
        {currentPage} of {totalPages}
      </Text>

      {/* Правая часть: Следующая и Последняя */}
      <Flex gap="4px">
        <Button
          onClick={() => handlePageClick(currentPage + 1)}
          isDisabled={currentPage === totalPages}
          variant="solid-lg"
          borderRadius="full"
          w="64px"
          h="56px"
          p="0"
        >
          <ArrowPaginateIcon fontSize="24px" />
        </Button>
        <Button
          onClick={() => handlePageClick(totalPages)}
          isDisabled={currentPage === totalPages}
          variant="solid-lg"
          borderRadius="full"
          w="64px"
          h="56px"
          p="0"
        >
          <DoubleArrowPaginateIcon fontSize="24px" />
        </Button>
      </Flex>
    </Flex>
  );
};

export default PaginationMobile;
